import { CTRL_MODULOS } from '@/common/boot/Constantes'

const BASE = [
  { key: 'redirecionar',         label: 'Ficha Técnica',            sortable: false },
]

const INSTALACAO = [
  { key: 'os', label: 'OS', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'provedor_instalacao.provedor.nome', label: 'Provedor', sortable: false },
  { key: 'provedor_instalacao.ctrl_estado_provedor.uf', label: 'UF', sortable: false },
  { key: 'provedor_instalacao.provedor.cm', label: 'CM', sortable: false },
  { key: 'provedor_instalacao.ctrl_regional.regional', label: 'Regional', sortable: false },
  { key: 'provedor_instalacao.cliente.nome_fantasia', label: 'Cliente', sortable: false },
  { key: 'created_at', label: 'Data de abertura', sortable: false },
  { key: 'finalized_at', label: 'Data de fechamento', sortable: false },
]

const RECUPERACAO = [
  { key: 'provedor_recuperacao.numero_rec', label: 'REC', sortable: false },
  { key: 'centro_funcional', label: 'Centro Funcional', sortable: false },
  { key: 'tarefa', label: 'Tarefa/Etapa', sortable: false },
  { key: 'data_abertura', label: 'Data de abertura', sortable: false },
  { key: 'data_fechamento', label: 'Data de fechamento', sortable: false },
  { key: 'provedor_recuperacao.designacao.designacao', label: 'Designação', sortable: false },
  { key: 'provedor_recuperacao.designacao.acesso_lp', label: 'Designação Provedor', sortable: false },
  { key: 'provedor_recuperacao.provedor.nome', label: 'Provedor', sortable: false },
]

const COLUNAS_POR_MODULO = {
  [CTRL_MODULOS.INSTALACAO]: INSTALACAO,
  [CTRL_MODULOS.RECUPERACAO]: RECUPERACAO,
}

export function colunasParaTipos(moduloAtivo) {
  return [
    ...BASE,
    ...(COLUNAS_POR_MODULO[moduloAtivo] ?? []),
  ]
}
